import DayPickerInput from './DayPickerInput';

export default DayPickerInput;
